// These are from style guide https://www.figma.com/design/riOZDOlKA620gf28gVQTwW/SureCo-Website-2023?node-id=9134-13141

export const titleFontFamily = "'Rocky', 'Helvetica Now Display', sans-serif"
export const defaultFontFamily = "'Helvetica Now Display', sans-serif"
